module.exports = __webpack_public_path__ + "static/media/iovation.acbc0429.svg";